import { useState, useEffect } from 'react'
import { toast } from '@sales-center/components'
import { useAppDispatch } from '@user/store/hooks/useAppDispatch'
import { getSalesFunnelSummary } from '../api'
import { useSelector } from 'react-redux'
import { selectSalesFunnelFilters } from '../slice'

export const useGetSalesFunnelSummaryOnMount = () => {
  const dispatch = useAppDispatch()

  const { filters } = useSelector(selectSalesFunnelFilters)

  const [status, setStatus] = useState<'pending' | 'success' | 'fail'>(
    'pending',
  )

  useEffect(() => {
    let mounted = true

    const execute = async () => {
      try {
        const result = await dispatch(getSalesFunnelSummary())

        if (mounted) {
          if (getSalesFunnelSummary.fulfilled.match(result)) {
            setStatus('success')
          } else {
            setStatus('fail')
            toast.error('Error loading sales funnel summary.')
          }
        }
      } catch {
        if (mounted) {
          setStatus('fail')
        }
      }
    }
    execute()

    return () => {
      mounted = false
    }
  }, [dispatch, filters])

  return status
}
